import {Component, Input, Output, forwardRef, EventEmitter, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';

import {AbstractFieldClass} from '../abstract-field.class';
import {DirectoryService} from '../../../services/directory.service';

declare const swal: any;

@Component({
    selector: 'settings-amenity-payments-field',
    templateUrl: './settings-amenity-payments-field.component.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SettingsAmenityPaymentsFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => SettingsAmenityPaymentsFieldComponent), multi: true}
    ]
})
export class SettingsAmenityPaymentsFieldComponent extends AbstractFieldClass implements OnInit {
    @Input('value') _value = [];
    @Input() title = '';
    @Input() userId: number;
    @Output('reset') resetPhones: EventEmitter<any> = new EventEmitter<any>();
    addNew = false;
    emptyFee = {active: false, required: false, name: '', amount: ''};

    constructor(public directoryService: DirectoryService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

    apply(): void {
        super.apply();
    }

    addNewFee(index) {
            this._value.splice(index + 1, 0, this.emptyFee);
            this.isEditMode = true;
    }
    removeFee(index) {
        if(this._value.length > 1)
            this._value.splice(index, 1);
        else {
            this._value.splice(index, 1);
            super.apply();
        }
    }

    validator(value: any): boolean {
        return undefined;
    }

    cancel() {
        super.cancel();
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/settings-amenity-payments-field/settings-amenity-payments-field.component.ts